var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-engagement-tool-selection',{attrs:{"pageHeadingInfo":_vm.pageHeadingInfo,"carddata":_vm.carddata,"menudata":_vm.menudata},on:{"onselectmenu":_vm.selectmenu,"OnClick1":_vm.handle_function_call,"OnClick2":_vm.handle_function_call}})
}
var staticRenderFns = []

export { render, staticRenderFns }